import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'

const config = {
  types: [
    {
      title: 'default',
      isDefault: true
    }
  ],
  modifiers: ['inverse'],
  states: []
}

const renderLinkList = (props, disabled) => {
  if (!props) return
  const listItems = props.map((link, index) => (
    <li key={index} className="mdn-LinkList-item">
      <a
        {...link.linkProps}
        className="mdn-LinkList-anchor"
        target={link.target}
        href={link.href}
        disabled={link.isDisabled || disabled}
      >
        {link.title}
      </a>
    </li>
  ))
  return listItems
}

export default function LinkList(props) {
  const { data, disabled, inverse, ...rest } = props
  return (
    <ul {...rest} className={resolveProps(props, config, 'LinkList')}>
      {renderLinkList(data, disabled)}
    </ul>
  )
}

LinkList.propTypes = {
  disabled: PropTypes.bool,
  inverse: PropTypes.bool,
  data: PropTypes.array,
  config: PropTypes.object
}
